module.exports = __webpack_public_path__ + "img/v3-logo.d96a201d.png";